// Lightweight confetti burst built on framer-motion. Honey/amber palette.
// Renders nothing when reduced motion is requested.

import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const COLORS = ['#FBBF24', '#F59E0B', '#FCD34D', '#FFFFFF', '#D97706'];

const Confetti = ({ active = false, count = 90, reducedMotion = false }) => {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        size: 6 + Math.random() * 8,
        delay: Math.random() * 0.6,
        duration: 2.6 + Math.random() * 2.4,
        rotate: Math.random() * 360,
        drift: (Math.random() - 0.5) * 220,
        color: COLORS[i % COLORS.length],
        round: Math.random() > 0.6,
      })),
    [count]
  );

  if (!active || reducedMotion) return null;

  return (
    <div className="rf-confetti" aria-hidden="true">
      {pieces.map((p) => (
        <motion.span
          key={p.id}
          className="rf-confetti__piece"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.round ? p.size : p.size * 0.4,
            borderRadius: p.round ? '50%' : '2px',
            background: p.color,
          }}
          initial={{ y: '-10vh', x: 0, opacity: 1, rotate: 0 }}
          animate={{ y: '110vh', x: p.drift, opacity: [1, 1, 0], rotate: p.rotate }}
          transition={{ duration: p.duration, delay: p.delay, ease: 'easeIn' }}
        />
      ))}
    </div>
  );
};

export default Confetti;
